var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    fillOpacity: 0.2,
    style: {
      fill: "white",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5734_97913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25545 14.7156C6.57212 12.0447 4.86859 8.63934 6.88387 6.61389C6.92841 6.56938 6.97295 6.52487 7.03975 6.48036C7.80801 5.91279 8.5206 5.77924 8.98824 6.45809L10.4023 8.45014C10.881 9.12901 10.7808 9.54076 10.2464 10.0861L9.80103 10.5646C9.65628 10.7204 9.71195 10.9207 9.77877 11.0543C10.0126 11.4438 10.5693 12.1338 11.2039 12.7681C11.8497 13.4135 12.5178 13.9478 12.9186 14.1926C13.0744 14.2817 13.3083 14.3039 13.4307 14.1703L13.8872 13.7252C14.3994 13.2133 14.8448 13.102 15.524 13.5694C16.4481 14.2259 17.016 14.6155 17.5504 15.005C18.2185 15.5058 18.0737 16.2848 17.5616 16.8635C17.4948 16.9413 17.4391 17.0193 17.3611 17.0972C15.3458 19.1115 11.9277 17.4088 9.25545 14.7156Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5734_97913",
    x: 5,
    y: 6,
    width: 14,
    height: 13.9805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5734_97913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5734_97913",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall1);
export default __webpack_public_path__ + "static/media/call_1.04573d44f49582e1118b89766bee8a01.svg";
export { ForwardRef as ReactComponent };